import { set, toggle } from '../../../utils/vuex'

export default {
  setDrawer: set('drawer'),
  toggleDrawer: toggle('drawer')
}



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js